import { useQuery } from '@tanstack/react-query'
import { throwIfApiError } from 'utils/error-handling/throwifApiError'
import { CommentResponse, CommentsHttpClient } from '@omnea-app/comments/commentsHttpClient'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'

export const mentionsPageSize = 50

export const mentionsQueryKey = 'mentions'

export const getMentionsQueryKey = (isResolved: boolean, requestId?: string) => [
  mentionsQueryKey,
  isResolved ? 'resolved' : 'unresolved',
  ...(requestId ? [requestId] : []),
]

export type MentionsResponse = CommentResponse<'/mentions', 'get'>

export const useGetMentions = (options: { isResolved: boolean; requestId?: string }) => {
  const { getToken } = useAuthenticatedUser()
  const { isResolved, requestId } = options

  return useQuery({
    queryKey: getMentionsQueryKey(isResolved, requestId),
    queryFn: async () => {
      const apiClient = new CommentsHttpClient({ authorization: await getToken() })
      const { data, error } = await apiClient.POST('/mentions', {
        body: { paginationModel: { page: 0, pageSize: mentionsPageSize }, isResolved, requestId },
      })
      throwIfApiError(error)
      return data
    },
  })
}
